import { render } from "./AccountingDocumentsComponent.vue?vue&type=template&id=e0ca9d96"
import script from "./AccountingDocumentsComponent.vue?vue&type=script&lang=js"
export * from "./AccountingDocumentsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__